<template>
    <ContentOrLoading>
        <b-row v-if="!loading">                
            <b-col cols="12">
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Abonos" lazy>
                            <DatosAbonos :lista_id="lista_id" :user_id="user_id" />
                        </b-tab>
                        <b-tab title="Deportistas" lazy>
                            <DatosBases :lista_id="lista_id" :user_id="user_id" />
                        </b-tab>
                        <b-tab title="Datos tarjeta" :active="activo == 'tarjeta'" lazy>
                            <DatosTarjeta v-if="user.info_pago" @actualizarInfo="getUsuario(true)"></DatosTarjeta>
                            <div class="text-center" v-else>
                                <h3>{{ $t('perfil.no_info_pago') }}</h3>
                                <b-btn @click="showModal('editarInfo')">Añadir tarjeta</b-btn>
                                <EditarInfoPagoModal :tid="configuracion.hash_teatro" :user_id="user.id" :nueva_alta="nueva_alta" @close="closeModal('editarInfo')" @setActive="activo = 'tarjeta'" />
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </ContentOrLoading>
</template>

<script>
import DatosTarjeta from './components/DatosTarjeta';
import EditarInfoPagoModal from './components/EditarInfoPagoModal';
import DatosBases from './components/DatosBases';
import DatosAbonos from './components/DatosAbonos';

export default {
    props: ['lista_id', 'user_id'],
    data() {
        return {
            loading: true,
            user: null,
            activo: null,
        }
    },
    methods: {
        getUsuario(tarjeta_actualizada = false) {
            this.loading = true;

            if (tarjeta_actualizada) {
                this.activo = 'tarjeta';
            }

            const params = {
                filters: {
                    lista_id: this.lista_id,
                    per_page: this.per_page
                },
                user_id: this.user_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.usuarios.get'), params).then(res => {
                this.user = res.data.user;
            }).finally(() => {
                this.loading = false;
            });
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.getUsuario();
            this.$modal.hide(modal);
        }
    },
    created() {
        this.getUsuario();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        nueva_alta() {
            return this.user && this.user.info_pago ? false : true;
        }
    },
    components: {
        DatosTarjeta, EditarInfoPagoModal, DatosBases, DatosAbonos
    }    
}
</script>